<template>
<v-layout column justify-start fill-height class="nx-bag">
  <nx-tabs class="nx-bag__tabs" dark
           color="nx-primary--darken-3"
           :tabs="availableTabs"
           :value="tab"
           @input="changeTab" />
  <nx-bag-saved-searches v-show="tab === tabs.SAVED_SEARCHES" />
  <nx-bag-internal-tags v-show="tab === tabs.INTERNAL_TAGS" />
  <nx-bag-clipboard v-if="tab === tabs.CLIPBOARD" />
</v-layout>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import NxBagClipboard from './BagClipboard';
import NxBagInternalTags from './BagInternalTags';
import NxBagSavedSearches from './BagSavedSearches';
import { tabs } from './store';
import NxTabs from '@/components/Tabs';

export default {
  name: 'nx-bag',
  components: {
    NxTabs,
    NxBagClipboard,
    NxBagInternalTags,
    NxBagSavedSearches,
  },
  data() {
    return {
      tabs,
    };
  },
  computed: {
    ...mapState('bag', ['tab']),
    ...mapGetters('bag', ['availableTabs', 'canReceiveContents']),
  },
  methods: {
    changeTab(tab) {
      this.$store.dispatch('bag/CHANGE_TAB', tab);
    },
  },
};
</script>

<style lang="stylus">
@import "../../assets/stylus/variables.styl"

.nx-bag {
  background-color: $nx-primary--darken-3;
  color: #fff;
  height: 100%;
  overflow: hidden;

  &__tabs {
    padding: 0 20px;
    box-shadow: 0 1px 0 0 black;
  }

  &__container {
    flex: 1 1 auto;
    overflow-y: auto;
    padding: 0;
    box-shadow: inset 0 -1px 0 0 black;
  }

  // Disable scroll arrows in tabs
  .v-tabs__wrapper--show-arrows {
    margin: 0;
  }
  .v-tabs__icon--prev {
    display: none;
  }
  .v-tabs__icon--next {
    display: none;
  }
}
</style>
